import React from 'react';
import { STATUS_CONFIG } from '../utils/constants';

export default function StatusBadge({ statut, size = 'sm' }) {
  const cfg = STATUS_CONFIG[statut] || { label: statut || 'Inconnu', dot: 'bg-gray-400', bg: 'bg-gray-100', text: 'text-gray-600' };
  const padding = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${padding} ${cfg.bg} ${cfg.text}`} data-testid={`status-badge-${statut}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot}`}></span>
      {cfg.label}
    </span>
  );
}
